"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MASS_GET_PARTICIPANTS_CHUNK_SIZE = exports.PAID_LOGICAL_STATUSES = void 0;
const payment_enums_1 = require("../../payment/types/enums/payment.enums");
exports.PAID_LOGICAL_STATUSES = [payment_enums_1.PaymentStatusEnum.FULLY_PAID, payment_enums_1.PaymentStatusEnum.REFUNDED, payment_enums_1.PaymentStatusEnum.VOID];
exports.MASS_GET_PARTICIPANTS_CHUNK_SIZE = 100;
//# sourceMappingURL=consts.js.map